import { render } from "./BoosterGallery.vue?vue&type=template&id=ffa36d62&scoped=true"
import script from "./BoosterGallery.vue?vue&type=script&lang=js"
export * from "./BoosterGallery.vue?vue&type=script&lang=js"

import "./BoosterGallery.vue?vue&type=style&index=0&id=ffa36d62&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa36d62"]])

export default __exports__